import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

const AdditionalResources = (props) => {
  useEffect(() => {
    document.getElementsByTagName("aside")[0].click();
  }, [props.location.key]);
  return (
    <>
      <div className="additional_info">
        <h3>Additional {props.vendorCommon.name} Information & Resources</h3>

        {props.vendorCommon.testimonial_count ? (
          <p>
            {`Read `}
            <Link to={`/vendor/${props.match.params.id}/testimonials`}>
              <u>
                {props.vendorCommon.name} Reviews, Testimonials & Customer
                References
              </u>
            </Link>
            {` from ${props.vendorCommon.testimonial_count?.toLocaleString()} real ${
              props.vendorCommon.name
            } customers.`}
          </p>
        ) : null}

        {props.vendorCommon.casestudy_count ? (
          <p>
            {`Browse `}
            <Link to={`/vendor/${props.match.params.id}/case-studies`}>
              <u>
                {props.vendorCommon.name} Case Studies, Customer Success
                Stories, & Customer References
              </u>
            </Link>
            {` from ${props.vendorCommon?.casestudy_count?.toLocaleString()} businesses that use ${
              props.vendorCommon.name
            }.`}
          </p>
        ) : null}

        {props.vendorCommon.video_count ? (
          <p>
            {`Watch `}
            <Link to={`/vendor/${props.match.params.id}/customer-videos`}>
              <u>{props.vendorCommon.name} Customer Videos</u>
            </Link>
            {` to learn why ${props.vendorCommon.video_count?.toLocaleString()} businesses chose ${
              props.vendorCommon.name
            }.`}
          </p>
        ) : null}

        {props.vendorCommon.is_faq_tab ? (
          <p>
            {`Explore answers to `}
            <Link to={`/vendor/${props.match.params.id}/faq`}>
              <u>frequently asked questions about {props.vendorCommon.name}.</u>
            </Link>
          </p>
        ) : null}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
  };
};

export default connect(mapStateToProps)(withRouter(AdditionalResources));
